import ColorHash from "color-hash";

import { colorPool } from "@/module/service-configs-module/statistics-visualization-module/first-svetofor/util";

export const COLOR_HASH = new ColorHash({
  hue: [
    { min: 300, max: 360 },
    { min: 0, max: 160 },
  ],
});

export const COLORS = {
  loser: colorPool[0],
  winner: colorPool[1],
  hero: colorPool[3],
};

export const round = (value: unknown) => {
  return Number(parseFloat(String(value)).toFixed(2));
};
